const transformPerformanceData = (input) => {
    let output = {};
    for (const key in input) {
        const element = input[key];
        output[key] = JSON.parse(element);
    }
    return output;
};
export default transformPerformanceData;
